import { RoomRatesWithRates } from '~/components/Accommodation/Pages/PropertyDetails/sections/AccommodationPropertyRates/AccommodationPropertyRatesSection';

import { RoomRates } from '~/services/AccommodationService';

export const filterRates = (
  rooms: RoomRates,
): {
  roomRates: RoomRatesWithRates;
  hotelOnlyRates: RoomRatesWithRates;
  hotelWithFlightRates: RoomRatesWithRates;
} => {
  const roomRates: RoomRatesWithRates = Object.fromEntries(
    Object.entries(rooms).map(([roomId, room]) => [
      roomId,
      {
        ...room,
        rates: Object.values(room.ratesMap),
      },
    ]),
  );
  const hotelOnlyRates: RoomRatesWithRates = Object.fromEntries(
    Object.entries(roomRates).map(([roomId, room]) => [
      roomId,
      {
        ...room,
        rates: room.hotelOnlyRates.map((rateId) => room.ratesMap[rateId]),
      },
    ]),
  );
  const hotelWithFlightRates: RoomRatesWithRates = Object.fromEntries(
    Object.entries(roomRates).map(([roomId, room]) => [
      roomId,
      {
        ...room,
        rates: room.hotelWithFlightRates.map((rateId) => room.ratesMap[rateId]),
      },
    ]),
  );
  return { roomRates, hotelOnlyRates, hotelWithFlightRates };
};
